import Vue from 'vue'
import {
  Menu, Submenu, MenuItem, Carousel, CarouselItem, Row, Col, Card, Divider, Breadcrumb, BreadcrumbItem, Progress, Form, FormItem, Input, Pagination, Button, Container, Header, Aside, Main, Footer, Message, Skeleton, SkeletonItem, Popover, Image, Icon
} from 'element-ui'

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Divider)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Progress)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Icon)
Vue.prototype.$message = Message
